import * as React from "react";
export function UsersIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={11}
      fill="none"
      {...props}
    >
      <path
        fill="#A7A7A7"
        d="M7.725 2.312a2.06 2.06 0 1 1-4.12 0 2.06 2.06 0 0 1 4.12 0M12.359 3.085a1.803 1.803 0 1 1-3.606 0 1.803 1.803 0 0 1 3.606 0"
      />
      <path
        fill="#A7A7A7"
        fillRule="evenodd"
        d="M11.571 8.726a6.17 6.17 0 0 0-1.743-2.743 4.16 4.16 0 0 1 2.407.287 4.4 4.4 0 0 1 1.42 1.005 4.64 4.64 0 0 1 1.04 1.758c.266.81-.45 1.519-1.303 1.519h-2.097c.342-.5.486-1.15.276-1.826"
        clipRule="evenodd"
      />
      <path
        fill="#A7A7A7"
        d="M9.271 10.552c.854 0 1.567-.707 1.315-1.522a5.149 5.149 0 0 0-9.84 0c-.251.815.463 1.522 1.316 1.522z"
      />
    </svg>
  );
}
